import { generateBulkDuplicateEditorPath } from 'modules/campaigns/services/utils';
import { CAMPAIGN_DIMENSION } from 'services/campaignDimension';

const bulkDuplicateCreative =
    ({ accountId, navigate }) =>
    _ => {
        const bulkDuplicateCreativePath = generateBulkDuplicateEditorPath({
            accountId,
            dimension: CAMPAIGN_DIMENSION.SPONSORED,
        });

        navigate(bulkDuplicateCreativePath);
    };

export default bulkDuplicateCreative;
